import { endpoints, host } from '@config/endpoints';
import request from './request';

export interface TSignInParams {
    userName: string;
    password: string;
    token: string;
    provider: string;
    remember: boolean;
}

export async function signIn(data: TSignInParams) {
    const { path, method } = endpoints.users.login;

    const { remember, ...restData } = data;
    let err = null;
    let res: any = null;

    try {
        ({ data: res } = await request(
            `${host}${path}`,
            method,
            restData,
            {},
        ));
        localStorage.setItem('labour-navigator-jwt-token', res.token);
        localStorage.setItem('labour-navigator-refresh-token', res.refreshToken);
        localStorage.setItem('firstName', res.firstName);
        localStorage.setItem('lastName', res.lastName);
        localStorage.setItem('originalUsername', res.originalUsername);
        remember && localStorage.setItem('keepSignedIn', String(remember));
    } catch (error) {
        // @ts-ignore
        err = error.message;
    }

    return [err, res];
}
